<template>
    <div>
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col cols="12" :md="$router.currentRoute.params.id ? 7 : 12">
                        <b-card no-body>
                            <b-card-header>
                                <h4 v-if="document.Id" class="card-title">{{ i18nT(`Edit Quote`) }}</h4>
                                <h4 v-else class="card-title">{{ i18nT(`Create quote`) }}</h4>
                            </b-card-header>
                            <b-card-body>
                                <!-- Invoice information -->
                                <b-row class="border-bottom pb-2" >
                                    <!-- Field: Username -->
                                    <b-col cols="12" md="12">
                                        <h5 class="mb-2">{{ i18nT(`Main information`) }}</h5>
                                    </b-col>
                                    <b-col cols="12" md="12">
                                        <b-row>
                                            <!-- Project name -->
                                            <b-col cols="12" md="4">
                                                <b-form-group
                                                    :label="i18nT(`Project name`)"
                                                    label-for="Number"
                                                    class="required"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        :name="i18nT(`Project name`)"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="document.Label"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Quote number -->
                                            <b-col cols="12" md="4">
                                                <b-form-group
                                                    :label="i18nT(`Quote number`)"
                                                    label-for="Number"
                                                    class="required"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        :name="i18nT(`Quote number`)"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="document.QuoteNumber"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <!-- CURRENCY -->
                                            <b-col cols="12" md="4">
                                                <b-form-group
                                                    :label="i18nT(`Currency`)"
                                                    label-for="Vendor"
                                                    class="required"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        :name="i18nT(`Currency`)"
                                                        rules="required"
                                                    >
                                                        <b-form-select
                                                            v-model="document.Currency"
                                                            :options="currencyList"
                                                            :state="errors.length > 0 ? false:null"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <!-- VENDOR -->
                                            <b-col cols="12" md="4">
                                                <validation-provider #default="{ errors }"
                                                                     :name="i18nT(`Client`)"
                                                                     rules="required">
                                                    <b-form-group
                                                        :label="i18nT(`Client`)"
                                                        label-for="Vendor" class="required">
                                                        <div class="d-flex">
                                                            <b-input-group-prepend>
                                                                <b-button variant="primary"
                                                                          v-b-tooltip="i18nT(`Add new client`)"
                                                                          v-b-modal.add-vendor class="corners-straight-right">
                                                                    <font-awesome-icon :icon="['fas', 'plus']" />
                                                                </b-button>
                                                            </b-input-group-prepend>

                                                            <b-form-select class="corners-straight-left"
                                                                           v-model="document.VendorId" :options="vendorList" />


                                                        </div>
                                                        <small class="text-danger d-block">{{ errors[0] }}</small>

                                                        <span class="text-muted font-small-3">
                                                            {{
                                                                i18nT(`Select the client from the list or click on the PLUS icon to create a new one.`) }}
                                                        </span>

                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>

                                            <!-- RECIPIENT NAME -->
                                            <b-col cols="12" md="4" >
                                                <b-form-group
                                                    :label="i18nT(`Recipient name`)"
                                                    label-for="RecipientName"
                                                    class="required"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        :name="i18nT(`Recipient name`)"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="document.RecipientName"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <!-- RECIPIENT E-MAIL -->
                                            <b-col cols="12" md="4" >
                                                <b-form-group
                                                    :label="i18nT(`Recipient e-mail`)"
                                                    label-for="RecipientEmail"
                                                    class="required"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        :name="i18nT(`Recipient e-mail`)"
                                                        rules="required"
                                                    >
                                                        <b-form-input
                                                            v-model="document.RecipientEmail"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Quote date -->
                                            <b-col cols="12" md="6">
                                                <b-form-group
                                                    :label="i18nT(`Quote date`)"
                                                    label-for="quoteDate"
                                                    class="required"
                                                >
                                                    <validation-provider
                                                        #default="{ errors }"
                                                        :name="i18nT(`Quote date`)"
                                                        rules="required"
                                                    >
                                                        <date-picker
                                                            id="quote-datepicker"
                                                            v-model="document.QuoteDate"
                                                        />
                                                        <small class="text-danger">{{ errors[0] }}</small>
                                                    </validation-provider>
                                                </b-form-group>
                                            </b-col>
                                            <!-- Quote expiration date -->
                                            <b-col cols="12" md="6">
                                                <b-form-group
                                                    :label="i18nT(`Expiration date`)"
                                                    label-for="dueDate"
                                                >
                                                    <date-picker
                                                        id="due-datepicker"
                                                        v-model="document.ExpirationDate"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                        </b-row>

                                    </b-col>
                                </b-row>

                                <!-- Notes and localization -->
                                <b-row class="border-bottom pb-2 pt-2">
                                    <b-col cols="12" md="12">
                                        <h5 class="mb-2">{{ i18nT(`Notes and localization`) }}</h5>
                                    </b-col>
                                    <b-col cols="12" md="12">
                                        <b-row>
                                            <!--INTERNATIONAL COMPANY INFO -->
                                            <b-col cols="12" md="6">
                                                <b-form-group :label="i18nT(`Billing information`)" label-for="International">
                                                    <b-form-checkbox switch v-model="document.UseInternational">
                                                        {{ i18nT(`Use international company info`) }}
                                                    </b-form-checkbox>
                                                </b-form-group>
                                            </b-col>

                                            <!--Quote language -->
                                            <b-col cols="12" md="6">
                                                <b-form-group :label="i18nT(`Quote Language`)" label-for="Language">
                                                    <b-form-select v-model="document.Lang" :options="languageList">
                                                    </b-form-select>
                                                </b-form-group>
                                            </b-col>

                                            <!-- Message -->
                                            <b-col cols="12" md="6">
                                                <b-form-group
                                                    :label="i18nT(`Message`)"
                                                    label-for="description"
                                                >
                                                    <b-form-textarea
                                                        id="textarea-default"
                                                        rows="3"
                                                        v-model="document.Description"
                                                    />
                                                </b-form-group>
                                            </b-col>

                                            <!-- Internal note -->
                                            <b-col cols="12" md="6">
                                                <b-form-group
                                                    :label="i18nT(`Internal note`)"
                                                    label-for="internalNote"
                                                >
                                                    <b-form-textarea
                                                        id="textarea-default"
                                                        rows="3"
                                                        v-model="document.InternalComments"
                                                    />
                                                    <span class="text-muted font-small-3">{{i18nT(`Internal notes are confidential and are not visible to your client.`)}}</span>
                                                </b-form-group>
                                            </b-col>

                                        </b-row>
                                    </b-col>
                                </b-row>

                                <!-- Payment Items -->
                                <b-row class="border-bottom pt-2 pb-2">
                                    <b-col cols="12" md="12">
                                        <h5>{{ i18nT(`Quote items`) }}</h5>
                                    </b-col>
                                    <b-col cols="12" md="12">
                                        <div
                                            v-for="(item, index) in paymentItems"
                                            :key="index"
                                            class="border-bottom pb-1 pt-1"
                                        >
                                            <b-row>
                                                <!--ITEM -->
                                                <b-col
                                                    cols="12"
                                                    md="4"
                                                >
                                                    <b-form-group :label="i18nT(`Item description`)" label-for="item" class="required">
                                                        <validation-provider #default="{ errors }"
                                                                             :name="i18nT(`Item description`)"
                                                                             rules="requiredTypeahead">

                                                            <vue-bootstrap-typeahead
                                                                v-model="item.Label"
                                                                :data="suggestionsList"
                                                                :serializer="returnText"
                                                                :inputClass="errors.length ? 'is-invalid' : null"
                                                                @hit="selectedOption => updateItemProperties(selectedOption, index)" />


                                                            <span v-if="index == 0" class="text-muted font-small-3">{{
                                                                    i18nT(`You can predefine items, products, and services in`) }}
                                                            <b-link target="_blank" :to="'/ac/settings/invoice-items'">{{
                                                                    i18nT(`Settings`) }}</b-link></span>

                                                            <small class="text-danger d-block">{{ errors[0] }}</small>

                                                        </validation-provider>
                                                    </b-form-group>
                                                </b-col>
                                                <!--QUANTITY -->
                                                <b-col
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <b-form-group
                                                        :label="i18nT(`Qty`)"
                                                        label-for="salaryNet"
                                                    >
                                                        <b-form-input
                                                            v-model="item.Quantity"
                                                            placeholder="1"
                                                            type="number"
                                                        />
                                                    </b-form-group>
                                                </b-col>

                                                <!--UNIT PRICE -->
                                                <b-col
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <b-form-group
                                                        :label="i18nT(`Unit price`)"
                                                        label-for="salaryNet"
                                                    >
                                                        <b-form-input
                                                            v-model="item.UnitPrice"
                                                            type="number"
                                                        />
                                                    </b-form-group>
                                                </b-col>

                                                <!--DISCOUNT -->
                                                <b-col
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <b-form-group
                                                        :label="i18nT(`Discount`)"
                                                        label-for="discount"
                                                    >
                                                        <b-form-input
                                                            v-if="discountType == 'single'"
                                                            v-model.number="item.DiscountAmount"
                                                            placeholder="0.00"
                                                            min="0"
                                                            type="number"
                                                        />
                                                        <b-form-input
                                                            v-else
                                                            :value="itemDiscount(index) | money"
                                                            placeholder="0"
                                                            type="number"
                                                            readonly
                                                        />
                                                    </b-form-group>
                                                </b-col>

                                                <!--SUBTOTAL -->
                                                <b-col
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <b-form-group
                                                        :label="i18nT(`Subtotal`)"
                                                        label-for="salaryNet"
                                                    >
                                                        <b-form-input
                                                            :value="itemSubTotal(item, index) | money"
                                                            placeholder="1"
                                                            type="number"
                                                            class="mini-paddings"
                                                            readonly
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col v-if="document.UseInternational" cols="12" md="4">
                                                    <b-form-group :label="i18nT(`International item description`)" label-for="item">
                                                        <vue-bootstrap-typeahead v-model="item.LabelInternational"
                                                                                :data="suggestionsList" :serializer="returnText"
                                                                                @hit="selectedOption => updateItemProperties(selectedOption, index)" />
                                                    </b-form-group>
                                                    <span v-if="index == 0" class="text-muted font-small-3">{{
                                                            i18nT(`This item description will be shown to your international client. The standard label will be shown for accounting duplicate of the quote.`) }}</span>
                                                </b-col>
                                                <b-col v-if="document.UseInternational"  cols="12" md="4">
                                                </b-col>

                                                <b-col v-else  cols="12" md="8">
                                                </b-col>

                                                <!--VAT % -->
                                                <b-col
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <b-form-group
                                                        :label="i18nT(`VAT (%)`)"
                                                        label-for="VatPercent"
                                                    >
                                                        <b-form-input
                                                            v-model="item.VatPercent"
                                                            type="number"
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                                <!--TOTAL -->
                                                <b-col
                                                    cols="12"
                                                    md="2"
                                                >
                                                    <b-form-group
                                                        :label="i18nT(`Total`)"
                                                        label-for="salaryNet"
                                                    >
                                                        <b-form-input
                                                            :value="item.Total ? item.Total : 0 | money"
                                                            disabled
                                                            placeholder="0"
                                                        />
                                                    </b-form-group>
                                                </b-col>

                                            </b-row>
                                            <div class="text-right">
                                                <b-button
                                                    variant="outline-danger"
                                                    @click="removeItem(index)"
                                                >
                                                    <feather-icon icon="MinusCircleIcon"/>
                                                    {{ i18nT(`Remove`) }}
                                                </b-button>
                                            </div>
                                        </div>

                                        <div class="pt-1 mb-2">
                                            <b-button
                                                variant="outline-primary"
                                                @click="addItems"
                                            >
                                                <feather-icon icon="PlusCircleIcon"/>
                                                {{ i18nT(`Add quote item`) }}
                                            </b-button>
                                        </div>


                                        <!-- DISCOUNT TOGGLE -->
                                        <div class="border-bottom pb-1 pt-1">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group :label="i18nT(`Discount type:`)" label-for="discountType">
                                                        <b-form-radio-group
                                                            id="discount-selector"
                                                            v-model="discountType"
                                                            :options="discountOptions"
                                                            name="discount-options"
                                                            @change="toggleDiscountType"
                                                        ></b-form-radio-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="discountType == 'all'">
                                                <b-col cols="12" md="4" md-offset="8">
                                                    <b-form-group :label="i18nT(`Total quote discount amount`)" label-for="salaryNet">
                                                        <div class="d-flex">
                                                            <b-form-input class="corners-straight-right"
                                                                          :placeholder="i18nT(`0`)" v-model="discountValue"
                                                                          type="number" />
                                                            <div class="semi-button cursor-pointer"
                                                                 v-b-tooltip="i18nT(`Toggle discount mode`)"
                                                                 @click="toggleDiscountMode()">
                                                                <font-awesome-icon class="d-block text-white ml-2"
                                                                                   :icon="discountMode == 'percent' ? ['fa', 'percent'] : ['fa', 'dollar-sign']"></font-awesome-icon>
                                                            </div>
                                                        </div>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <!-- SUMMARIES -->
                                        <div>
                                            <b-row class="mt-1">
                                                <b-col cols="2">
                                                    {{ i18nT(`Items total`) }}
                                                </b-col>
                                                <b-col cols="10" class="pl-2">
                                                    <strong>{{ {amount: subtotalAll, currency: document.Currency} | currency }}</strong>
                                                </b-col>
                                            </b-row>

                                            <b-row class="mt-1" v-if="discountAmount > 0">
                                                <b-col cols="2">
                                                    {{ i18nT(`Discount`) }}
                                                </b-col>
                                                <b-col cols="10">
                                                    <strong class="text-danger">- {{  {amount: discountAmount || 0, currency: document.Currency} | currency }}</strong>
                                                </b-col>
                                            </b-row>

                                            <b-row class="mt-1">
                                                <b-col cols="2">
                                                    {{ i18nT(`Subtotal`) }}
                                                </b-col>
                                                <b-col cols="10" class="pl-2">
                                                    <strong>{{ {amount: (subtotalAll-discountAmount), currency: document.Currency} | currency }}</strong>
                                                </b-col>
                                            </b-row>

                                            <b-row class="mt-1">
                                                <b-col cols="2">
                                                    {{ i18nT(`VAT or Tax`) }}
                                                </b-col>
                                                <b-col cols="10" class="pl-2">
                                                    <strong>{{ {amount:totalVAT ? totalVAT : 0, currency: document.Currency} | currency }}</strong>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="6">
                                                    <b-row class="mt-1 mb-1 pt-1 border-top">
                                                        <b-col cols="6">
                                                            <h4>{{ i18nT(`Total`) }}</h4>
                                                        </b-col>
                                                        <b-col cols="6" class="pl-2">
                                                            <h4>
                                                                <strong>{{ {amount: finalTotal || 0, currency: document.Currency} | currency}}</strong>
                                                            </h4>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="12" md="6" class="pb-2">
                                                    <b-form-checkbox name="check-button" switch v-model="document.DisplayGeneralConditions">
                                                        {{ i18nT(`Add general terms and conditions to your quote`) }}
                                                    </b-form-checkbox>
                                                    <span class="text-muted font-small-3">{{
                                                            i18nT(`You can define your general terms and conditions in`) }}
                                                <b-link target="_blank" :to="'/ac/company-profile/general-terms'">
                                                  {{i18nT(`Organization profile`) }}
                                                </b-link>
                                              </span>
                                                </b-col>
                                            </b-row>
                                        </div>

                                    </b-col>
                                </b-row>

                                <!--Additional documents DROPZONE-->
                                <b-row class="border-bottom pt-2 pb-2">
                                    <b-col cols="12" md="2">
                                        <h5>
                                            {{ i18nT(`Additional documents`) }}
                                        </h5>
                                    </b-col>
                                    <b-col cols="12" md="10">
                                        <b-row>
                                            <b-col cols="12" md="12" :class="dropzone2HasError ? 'sk-error' : ''">
                                                <vue-dropzone ref="additionalDropzone"
                                                              :duplicateCheck="true"
                                                              @vdropzone-queue-complete="queCompleteMultiple"
                                                              @vdropzone-error="dropzoneErrorMultiple"
                                                              @vdropzone-added="onFileAdded"
                                                              @vdropzone-success="dropzoneSuccessMultiple"
                                                              id="dz-invoice-multiple"
                                                              class="sk-dropzone"
                                                              :options="dropzone2Options"></vue-dropzone>

                                                <div class="mt-2">
                                                    <b-list-group-item
                                                        v-for="(attachedDoc, index) in document.QuoteDocuments"
                                                        :key="attachedDoc.Id"
                                                        tag="li"
                                                    >
                                                        <b-row>
                                                            <b-col cols="6" class="d-flex align-items-center">
                                                                <b-link :href="attachedDoc.DownloadUrl" target="_blank" :download="attachedDoc.Label"><b>{{ attachedDoc.Label }}</b></b-link>
                                                            </b-col>
                                                            <b-col cols="4">
                                                                <label class="text-muted">{{ i18nT(`Document type`) }}</label>
                                                                <b-form-select
                                                                    v-model="document.QuoteDocuments[index].Type"
                                                                    :options="paymentCategoryList">

                                                                </b-form-select>
                                                            </b-col>
                                                            <b-col cols="2" class="d-flex align-items-center justify-content-end">
                                                                <b-button
                                                                    variant="danger"
                                                                    @click="removeAttachedDocument(index)"
                                                                >
                                                                    <feather-icon icon="Trash2Icon" size="16"></feather-icon>
                                                                </b-button>
                                                            </b-col>
                                                        </b-row>
                                                    </b-list-group-item>
                                                </div>

                                            </b-col>
                                        </b-row>

                                    </b-col>

                                </b-row>

                                <b-row align-h="end">
                                    <b-col cols="6" class="d-flex justify-content-end">
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                                  class="mt-0 mt-md-2 ml-1 mr-1" @click.prevent="validationForm">
                                            {{ i18nT(`Save`) }}
                                        </b-button>
                                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                                  class="mt-0 mt-md-2 ml-1 mr-1" @click.prevent="validationForm('preview')">
                                            {{ i18nT(`Save & Preview`) }}
                                        </b-button>
                                    </b-col>

                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-col>


                    <b-col v-if="document.IframePublicUrl" cols="12" md="5" class="sticky-col">
                        <iframe id="print-frame" class="sticky-column"
                                :src="document.IframePublicUrl+'&lang='+document.Lang+'&refresh='+refreshCount" width="100%" height="1000px"
                                frameborder="0"></iframe>
                        <div id="frame-spinner"

                             class="position-absolute
                                    w-100
                                    d-flex justify-content-center
                                    align-items-center align-content-center">
                            <b-spinner label="Loading..."
                                       variant="primary"
                                       class="mr-2"
                                       color="primary"></b-spinner>

                            <span>{{i18nT(`Loading invoice preview...`)}}</span>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
        <b-modal id="add-vendor" :title="i18nT(`Add new client`)" size="xl" hide-footer centered :no-close-on-backdrop="true"
                 :no-close-on-esc="true">
            <edit-vendor @vendorAdded="onVendorAdded" :modalMode="true" />
        </b-modal>
    </div>

</template>

<script>
import {
    BButton,
    // BAlert,
    // BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BForm,
    BCard,
    // BFormCheckbox,
    BFormTextarea,
    BCardBody,
    BFormSelect,
    BListGroupItem,
    BLink,
    VBModal,
    VBTooltip,
    // BTabs,
    // BTab,
    // BFormFile,
    // BInputGroup,
    // BInputGroupText,
    BCardHeader, BInputGroupPrepend, BFormCheckbox, BSpinner,
    // BDropdown,
    // BDropdownItem
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import {dictToSelectArray} from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate'
import {required, email} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import useAuth from '@/auth/useAuth';
import _ from 'lodash'
import {getCurrentInstance} from '@vue/composition-api'
import DatePicker from '@core/components/DatePicker.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {API_KEY} from "@core/utils/constants";
import EditVendor from "@/views/accounting/Vendors/EditVendor.vue";
//import store from "@/store";
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'

extend('requiredTypeahead', {
    validate: val => {
        // if it’s an object, make sure `.text` isn’t empty
        if (val && typeof val === 'object') {
            return String(val.text).trim().length > 0;
        }
        // otherwise, just do the normal non-empty check
        return String(val || '').trim().length > 0;
    }
});

export default {
    components: {
        BSpinner,
        BFormCheckbox,
        BInputGroupPrepend,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormRadioGroup,
        BFormInput,
        BForm,
        BCard,
        BCardBody,
        // vSelect,
        BFormTextarea,
        BFormSelect,
        // BAlert,
        // BBadge,
        // BFormCheckbox,
        BListGroupItem,
        BLink,
        // BTabs,
        // BTab,
        ValidationProvider,
        ValidationObserver,
        // BFormFile,
        // BInputGroup,
        // BInputGroupText,
        BCardHeader,
        // BDropdown,
        // BDropdownItem,
        VueDropzone: vue2Dropzone,
        DatePicker,
        EditVendor,
        VueBootstrapTypeahead
    },
    directives: {
        Ripple,
        'b-modal': VBModal,
        'b-tooltip': VBTooltip
    },

    data() {
        return {
            refreshCount: 0,
            document: {
                Discount: 0,
                IsQuote: 1,
                QuoteDocuments: [],
                QuoteFile: null,
                VendorId: null,
                DisplayGeneralConditions: 0,
                UseInternational: false,
                Lang: '',
            },
            selectedVendor: {},
            tempQuote: null,
            originalQuote: null,
            file: null,
            fileName: null,
            required,
            email,
            hasUrl: false,
            hasFile: false,
            originalFileName: null,
            vendorList: [],
            typeList: [],

            discountOptions: [
                { text: this.i18nT(`No discount`), value: 'none' },
                { text: this.i18nT(`Individual items`), value: 'single' },
                { text: this.i18nT(`The entire quote`), value: 'all' },
            ],
            discountType: 'none',
            discountMode: 'percent',
            discountValue: 0,
            discountAmount: 0,
            discounts: [],
            totalVAT: 0,


            paymentCategoryList: [],
            paymentTypeList: [],
            currencyList: [],
            languageList: [],
            suggestionsList: [],

            paymentItems: [
                {
                    Label: '',
                    Discount: 0,
                    DiscountAmount: 0,
                    LabelInternational: '',
                    Quantity: 1,
                    UnitPrice: 0,
                    Total: 0,
                    VatPercent: 0
                }
            ],

            additionalDocs: [
                {
                    Name: '',
                    Url: '',
                },
            ],


            dropzonePopulateFromResp: true,

            dropzone2HasError: false,

            dropzone2Options: {
                url: process.env.VUE_APP_API_URL+'quotes/quoteAttachments',
                addRemoveLinks: true,
                autoProcessQueue: true,
                clickable: true,
                dictDefaultMessage: this.i18nT(`Drag and drop additional files here`),
                dictRemoveFile: this.i18nT(`Remove`),
                //dictRemoveFileConfirmation: this.i18nT(`Are you sure you want to remove this file?`),
                dictFileTooBig: this.i18nT(`File is too big ({{filesize}}MB). Max filesize is: {{maxFilesize}}MB`),
                dictInvalidFileType: this.i18nT(`Only PDFs and JPGs are allowed`),
                dictCancelUpload: this.i18nT(`Cancel`),
                dictCancelUploadConfirmation: this.i18nT(`Are you sure you want to cancel this upload?`),
                dictMaxFilesExceeded: this.i18nT(`You can attach up to 10 files`),
                maxFilesize: 5,
                maxFiles: 10,
                acceptedFiles: 'image/*,application/pdf',
                headers: {
                    'Api-Key': API_KEY,
                    'Auth-Key': useAuth.getToken(),
                },
            },

        }
    },
    created() {
        this.document.Template = router.currentRoute.meta.template === 1
        this.softwares = _.values(useAuth.getSoftwares()).map(software => ({
            value: software.id,
            title: `${software.short.toUpperCase()} - ${software.title}`
        }))


        let curWorkspace = useAuth.getCurWorkspace();
        this.defaultVat = curWorkspace.MainVatPercent;

        if (!this.$route.params.id) {
            this.paymentItems[0].VatPercent = curWorkspace.MainVatPercent;
            this.document.Currency = curWorkspace.MainCurrency;
            this.document.Lang = curWorkspace.Language
        }


        Promise.all([
            new Promise((res) => {
                this.$http.get(
                    `vendors/vendorsList?clients=1`
                ).then(({data}) => {
                    this.vendorList = dictToSelectArray(data.data)
                    res()
                })
            }),
            new Promise((res) => {
                this.$http.get(
                    `system/financeTypes`
                ).then(({data}) => {
                    this.typeList = dictToSelectArray(data.data)
                    res()
                })
            }),
            new Promise((res) => {
                this.$http.get(
                    `system/paymentTypes`
                ).then(({data}) => {
                    this.paymentTypeList = dictToSelectArray(data.data)
                    res()
                })
            }),

            new Promise((res) => {
                this.$http.get(
                    `system/currencies`
                ).then(({data}) => {
                    this.currencyList = dictToSelectArray(data.data)
                    res()
                })
            }),
            new Promise((res) => {
                this.$http.get(
                    `invoices/categories`
                ).then(({data}) => {
                    this.paymentCategoryList = data.data.map(item => ({
                        value: item.Id,
                        text: item.Label
                    }))
                    res()
                })
            }),

            new Promise((res) => {
                this.$http.get(
                    `settings/invoiceItemSuggests`
                ).then(({data}) => {
                    this.suggestionsList = data.data.map(suggestion => ({
                        value: suggestion.Id,
                        text: suggestion.Label,
                        unitPrice: suggestion.Price,
                        vatPercent: suggestion.Vat,
                        discountAmount: 0,
                        fullData: suggestion
                    }))
                    res()
                })
            }),
            new Promise((res) => {
                this.$http.get(`system/cultures`).then(({data}) => {
                    this.languageList = dictToSelectArray(data.data)

                    res()
                })
            }),



        ]).then(() => {
            if (router.currentRoute.params.id) {
                this.dropzonePopulateFromResp = false;
                this.$http.get(
                    `quotes?id=${router.currentRoute.params.id}`
                ).then(({data}) => {
                    this.postProcessInvoice(data.data, true);
                })
            }
        })
    },
    computed: {

        hasRouteId() {
            return router && router.currentRoute.params.id
        },
        finalSubtotal() {
            return this.subtotalAll - (this.discountValue || 0);
        },
        totalAll(){
            return this.paymentItems.filter(item => !!item.UnitPrice && !!item.Quantity).reduce((acc, item) =>
                    (acc + (item.UnitPrice * item.Quantity * ((item.VatPercent ? item.VatPercent : 0) / 100 + 1))),
                0).toFixed(2) - (this.discountValue || 0)
        },
        subtotalAll(){
            return this.paymentItems.filter(item => !!item.UnitPrice && !!item.Quantity).reduce((acc, item) =>
                    (acc + item.UnitPrice * item.Quantity),
                0).toFixed(2);
        },
        finalTotal() {
            return parseFloat(this.subtotalAll - this.discountAmount) + parseFloat(this.totalVAT);
        },
        vendorId() {
            return this.document.VendorId
        },
    },
    methods: {
        onVendorAdded() {
            this.$bvModal.hide('add-vendor');
            this.$http.get(
                `vendors/vendorsList?clients=1`
            ).then(({ data }) => {
                this.vendorList = dictToSelectArray(data.data)
                this.document.VendorId = this.vendorList[this.vendorList.length - 1].value;
            });
        },
        updateTotalVat(){
            let total = 0;
            let self = this;

            if(this.paymentItems.length !== 0) {
                for (let i = 0; i < self.paymentItems.length; i++) {
                    total += (!!self.paymentItems[i].Quantity && !!self.paymentItems[i].UnitPrice) ?
                        ( (self.paymentItems[i].Quantity * self.paymentItems[i].UnitPrice)  - self.itemDiscount(i) )* (self.paymentItems[i].VatPercent / 100).toFixed(2) : 0;
                }
            }
            this.totalVAT = total;
        },
        updateTotals(itemList){
            let self = this;
            for (let i = 0; i < itemList.length; i++) {
                itemList[i].Total = (!!itemList[i].Quantity && !!itemList[i].UnitPrice) ?
                    ( (itemList[i].Quantity * itemList[i].UnitPrice)  - self.itemDiscount(i) )* (1 + (itemList[i].VatPercent ?? 0) / 100).toFixed(2)  + ""
                    : "0"
            }
            return itemList;
        },
        returnText(s) {
            return s.text;
        },
        updateItemProperties(selectedOption, index) {
            if (selectedOption && selectedOption.unitPrice) {
                this.$set(this.paymentItems[index], 'UnitPrice', selectedOption.unitPrice);
                this.$set(this.paymentItems[index], 'VatPercent', selectedOption.vatPercent ? selectedOption.vatPercent : 0);
                this.$set(this.paymentItems[index], 'Quantity', this.paymentItems[index].Quantity ? this.paymentItems[index].Quantity : 1);
            }
        },
        itemSubTotal(item, index) {
            if(!index){
                index = this.paymentItems.indexOf(item);
            }
            return item.Quantity * item.UnitPrice - this.itemDiscount(index)
        },
        itemDiscount(index){
            if(this.discountType == 'all'){
                return this.discounts[index] ? this.discounts[index] : 0;
            } else if (this.discountType == 'single'){
                return this.paymentItems[index].DiscountAmount ? this.paymentItems[index].DiscountAmount : 0;
            } else {
                return 0;
            }
        },
        calcActualDiscount() {
            let self = this;

            if(this.discountType === 'single') {
                this.discountAmount = 0;
                this.discounts = [];
                this.paymentItems.forEach(function (item, index) {
                    if (item.DiscountAmount) {
                        self.discounts[index] = item.DiscountAmount;
                        self.discountAmount += item.DiscountAmount;
                    } else {
                        self.discounts[index] = 0;
                    }
                });
            } else if (this.discountType === 'none') {
                this.discountAmount = 0;
                this.discounts = [];
            } else {
                if (this.discountMode == 'percent') {
                    this.discountAmount = this.subtotalAll * this.discountValue / 100;
                } else {
                    this.discountAmount = this.discountValue;
                }

                self.paymentItems.forEach(function (item, index) {
                    let proportion = item.UnitPrice * item.Quantity / self.subtotalAll;
                    self.paymentItems[index].DiscountAmount = self.discountAmount * proportion;
                    self.discounts[index] = self.discountAmount * proportion;
                });
            }

            return this.discountAmount
        },
        toggleDiscountType(){
            if (this.discountType === 'none' || this.discountType === 'single'){
                this.discountValue = 0;
            }
            this.calcActualDiscount();
        },

        toggleDiscountMode() {
            this.discountMode = this.discountMode == 'percent' ? 'amount' : 'percent';
            this.calcActualDiscount();
        },
        dropzoneAddParams(file, xhr, formData) {
            let isClient = this.document.Type === 2 ? 1 : 0;
            formData.append('isClient', isClient);
            this.$store.commit('app/REQUEST_PENDING')
        },

        removeAttachedDocument(index) {
            this.document.QuoteDocuments.splice(index, 1)
        },
        removePrimaryDocument(){
            this.document.QuoteFile = null;
            this.tempQuote = null;
        },
        postProcessInvoice(QuoteData, initialLoad  = false){
            this.document = QuoteData;
            this.document.IsQuote = this.document.IsQuote == 1
            this.paymentItems = [];
            this.paymentItems = this.document.QuoteItems


            if (this.document.DiscountType == 1) {
                this.discountType = 'all';
                if(this.document.DiscountPercent) {
                    this.discountMode = 'percent';
                    this.discountValue = this.document.DiscountPercent;
                } else if (this.document.DiscountAmount) {
                    this.discountMode = 'amount';
                    this.discountValue = this.document.DiscountAmount;
                }
            } else if (this.document.DiscountType == 2) {
                this.discountType = 'single';
            } else {
                this.discountType = 'none';
            }

            if(this.document.DisplayGeneralConditions === 1) {
                this.document.DisplayGeneralConditions = true;
            } else{
                this.document.DisplayGeneralConditions = false;
            }


            if(!initialLoad){
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: this.i18nT('Quote data updated from attachment'),
                        icon: 'CheckIcon',
                        variant: 'success'
                    }
                })
            }
            this.document.UseInternational = this.document.UseInternational ? true : false
        },
        dropzoneSuccessMultiple: function (files, response) {
            console.log("Multiple Success: ", files, response);
            this.document.QuoteDocuments.push(response.data);
        },

        dropzoneErrorMultiple(message){
            this.dropzone2HasError = true;
            this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                timeout: 9000,
                props: {
                    title: this.i18nT(message.previewElement.childNodes[7].innerText),
                    text: message.upload.filename,
                    icon: 'InfoIcon',
                    variant: 'danger',
                    timeout: 20000,
                },
            })
        },
        onFileAdded(file) {
            console.log("File added: ", file);
            //this.$refs.myVueDropzone.processQueue();
        },
        queComplete() {
            this.$refs.mainDropzone.removeAllFiles();
            //this.$refs.myVueDropzone.removeAllFiles();
        },

        queCompleteMultiple() {
            let self = this;

            setTimeout(function () {
                self.$refs.additionalDropzone.removeAllFiles();
                self.dropzone2HasError = false;
            }, 4000);
        },

        onFilePick: function () {
            this.$refs['filePicker'].$refs.input.click()
        },
        onFileDelete: function () {
            this.file = null
            this.fileName = ''
        },
        removeItem: function (index) {
            this.paymentItems.splice(index, 1)
        },
        validationForm(mode) {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    const formData = new FormData()
                    if (router.currentRoute.params.id) {
                        formData.append('id', router.currentRoute.params.id)
                    }

                    if (this.document.DisplayGeneralConditions) {
                        formData.append('DisplayGeneralConditions', 1)
                    } else {
                        formData.append('DisplayGeneralConditions', 0);
                    }

                    if (this.document.QuoteFile) {
                        formData.append('QuoteFileId', this.document.QuoteFile.Id)
                    }
                    formData.append('Label', this.document.Label)
                    formData.append('QuoteNumber', this.document.QuoteNumber)
                    formData.append('Currency', this.document.Currency)
                    formData.append('UseInternational', this.document.UseInternational ? 1 : 0)
                    formData.append('Lang', this.document.Lang)

                    formData.append('VendorId', this.document.VendorId)
                    formData.append('RecipientName', this.document.RecipientName)
                    formData.append('RecipientEmail', this.document.RecipientEmail)


                    formData.append('QuoteDate', this.document.QuoteDate)
                    if (this.document.ExpirationDate) {
                        formData.append('ExpirationDate', this.document.ExpirationDate)
                    }


                    formData.append('Description', this.document.Description)
                    formData.append('InternalComments', this.document.InternalComments)
                    formData.append('Discount', this.discountValue)
                    formData.append('DiscountType', this.document.discountType)
                    formData.append('DiscountAmount', this.discountAmount);
                    formData.append('DiscountPercent', this.discountMode === 'percent' ? this.discountValue : 0);


                    formData.append('PaymentType', this.document.PaymentType)
                    formData.append('Amount', this.paymentItems.filter(item => !!item.UnitPrice && !!item.Quantity).reduce((acc, item) =>
                            (acc + item.UnitPrice * item.Quantity),
                        0))

                    formData.append('VatAmount', this.totalVAT)
                    formData.append('TotalAmount', this.finalTotal)


                    formData.append('quote_document_ids', this.document.QuoteDocuments.map(doc => doc.Id).join(","))
                    formData.append('quote_document_types', this.document.QuoteDocuments.map(doc => doc.Type).join(","))


                    for (let i = 0; i < this.paymentItems.length; i++) {
                        if (this.paymentItems[i].Id){
                            formData.append(`quote_items[${i}][id]`, this.paymentItems[i].Id ?? 0)
                        }
                        formData.append(`quote_items[${i}][Title]`, this.paymentItems[i].Label)
                        if(this.document.UseInternational) {
                            formData.append(`quote_items[${i}][TitleInternational]`, typeof this.paymentItems[i].LabelInternational == 'object' ? this.paymentItems[i].LabelInternational.text : this.paymentItems[i].LabelInternational)
                        }
                        formData.append(`quote_items[${i}][UnitPrice]`, this.paymentItems[i].UnitPrice)
                        formData.append(`quote_items[${i}][Quantity]`, this.paymentItems[i].Quantity)
                        formData.append(`quote_items[${i}][Amount]`, this.paymentItems[i].Quantity * this.paymentItems[i].UnitPrice)
                        formData.append(`quote_items[${i}][VatAmount]`, this.paymentItems[i].VatPercent * this.itemSubTotal(this.paymentItems[i], i)/100)
                        formData.append(`quote_items[${i}][VatPercent]`, this.paymentItems[i].VatPercent)

                        formData.append(`quote_items[${i}][TotalAmount]`, (!!this.paymentItems[i].Quantity && !!this.paymentItems[i].UnitPrice) ? this.paymentItems[i].Quantity * this.paymentItems[i].UnitPrice * (1 + (this.paymentItems[i].VatPercent ?? 0) / 100) + "" : "0")
                        formData.append(`quote_items[${i}][Currency]`, this.document.Currency)

                        if(this.discountAmount){
                            formData.append(`quote_items[${i}][DiscountAmount]`, this.discounts[i])
                        }
                    }

                    this.$http.post(
                        'quotes', formData
                    ).then((res) => {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: this.successMessage(res),
                                icon: 'InfoIcon',
                                variant: 'success',
                            },
                        })

                        if(mode == 'preview'){
                            this.refreshCount++;
                            if(this.$router.currentRoute.name === 'quote-create') {
                                this.$router.push({ name: 'quote-edit', params: { id: res.data.data.Id } });
                            }

                        }else {
                            if (this.prevRoute && this.prevRoute.name === 'quotes') {
                                router.back()
                            }
                            else {
                                router.push({ name: 'quotes' })
                            }
                        }

                    })
                        .catch((err) => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: this.errorMessage(err),
                                    icon: 'InfoIcon',
                                    variant: 'danger',
                                },
                            })
                        })
                }else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: this.i18nT('Please fill all required fields'),
                            icon: 'InfoIcon',
                            variant: 'danger',
                        },
                    })
                }
            })
        },

        onDelete() {
            this.$swal({
                title: this.i18nT(`Are you sure you want to delete this entry?`),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.i18nT(`Confirm`),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(() => {
                this.$swal({
                    icon: 'success',
                    title: this.i18nT(`Deleted!`),
                    text:  this.i18nT(`Selected quote(s) were deleted!`),
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                })
                router.push({name: 'quotes'})
            })
        },
        setup() {
            const vm = getCurrentInstance()
            return {vm}
        },
        addItems() {
            this.paymentItems.push({
                Label: '',
                LabelInternational: '',
                Discount: 0,
                DiscountAmount: 0,
                Quantity: 1,
                UnitPrice: 0,
                Total: 0,
                TotalAmount: 0,
                VatPercent: 0,
                VatAmount: 0,
            })
        }
    },
    watch: {
        discountType: function (newVal) {
            if (newVal === 'none') {
                this.document.discountType = 0;
            } else if (newVal == 'single') {
                this.document.discountType = 2;
            } else {
                this.document.discountType = 1;
            }
        },
        file: function (val) {
            if (val) {
                this.file = val
                this.fileName = val.name
            } else {
                this.file = null
                this.fileName = ''
            }
        },
        paymentItems: {
            deep: true,
            handler: function (val) {
                this.paymentItems = this.updateTotals(val)
                this.updateTotalVat();
                this.calcActualDiscount();
            }
        },
        discountValue: function () {
            this.calcActualDiscount();
        },
        discountAmount: function () {
            this.paymentItems = this.updateTotals(this.paymentItems)
            this.updateTotalVat();
        },
        vendorId(newId, oldId){
            if(parseInt(newId) && newId !== oldId){
                this.$http.get(`vendors?id=${newId}`).then(({ data }) => {
                    this.selectedVendor = data.data;
                    if(this.selectedVendor){
                        if(this.selectedVendor.Contacts.length > 0){
                            this.document.RecipientEmail = this.document.RecipientName ? this.document.RecipientName : this.selectedVendor.Contacts[0].Mail
                            this.document.RecipientName = this.document.RecipientEmail ? this.document.RecipientEmail : this.selectedVendor.Contacts[0].Name
                        } else {
                            this.document.RecipientName = this.document.RecipientName ? this.document.RecipientName : this.selectedVendor.LegalRepresentative
                            this.document.RecipientEmail = this.document.RecipientEmail ? this.document.RecipientEmail : this.selectedVendor.BusinessEmail
                        }
                        this.document = {...this.document}

                    }
                });
            }
        },
        dropzonePopulateFromResp(newVal) {
            if(newVal && this.tempQuote){
                this.postProcessInvoice(this.tempQuote)
            }else if (!newVal && this.originalQuote){
                this.postProcessInvoice(this.originalQuote)
            }
        }
    },
}
</script>

<style lang="scss">

.mini-paddings {
    padding: 2px 4px;
}

.dicountIcon {
    position: relative;
    margin: 0 auto;
    margin-top: calc(50% - 1px);
}

.corners-straight-right {
    border-radius: 8px 0 0 8px;
    border-right:none;
}

.semi-button {
    border: 1px solid var(--gray);
    background: var(--primary);
    width: 64px;
    height: 38px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: 0 8px 8px 0;
}
.section-title {
    font-size: 11px;
}

.document-name {
    display: inline;
    line-height: 32px;
}

.document-actions-bar {
    float: right;
}
</style>
